import { render, staticRenderFns } from "./QualifierLabels.vue?vue&type=template&id=96e6a7ce&"
import script from "./QualifierLabels.vue?vue&type=script&lang=js&"
export * from "./QualifierLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports